angular.module('gym.components').directive('editAvailability', function() {
  return {
    restrict: 'E',
    template: require('templates/components/profile/editAvailability.html.slim'),
    scope: {
      trainerAvailability: '=',
      showAvailability: '&'
    },
    controller: ["$scope", "$timeout", "$document", "flash", "loadingAnimation", "EditAvailabilityService", "Locations", "Availability", "AppointmentTypes", function($scope, $timeout, $document, flash, loadingAnimation, EditAvailabilityService, Locations, Availability, AppointmentTypes) {
      var isAppointmentSelected, loadLocations, save;
      $scope.appointmentTypes = AppointmentTypes.getList({
        count: 1000
      }).$object;
      $scope.timeBuffers = [0, 5, 10, 15, 20, 25, 30];
      $scope.isFormReady = function() {
        return true;
      };
      loadLocations = function() {
        $scope.locations = [];
        return Locations.getList({
          count: 1000
        }).then(function(locations) {
          $scope.locations = locations;
          if (!$scope.trainerAvailability.id && locations.length) {
            return $scope.trainerAvailability.trainer_availability_blocks.forEach(function(block) {
              return block.location_id = locations[0].id;
            });
          }
        });
      };
      loadLocations();
      $scope.onTimeChanged = function(block) {
        if (!moment(block.start_time_obj).isValid()) {
          block.start_time_obj = moment().toDate();
        }
        if (!moment(block.end_time_obj).isValid()) {
          block.end_time_obj = moment().toDate();
        }
        block.start_time = moment(block.start_time_obj).format('HHmm');
        return block.end_time = moment(block.end_time_obj).format('HHmm');
      };
      $scope.toggleAppointment = function(block, id) {
        if (isAppointmentSelected(block, id)) {
          return block.appointment_type_ids = _.without(block.appointment_type_ids, id);
        } else {
          return block.appointment_type_ids.push(id);
        }
      };
      $scope.isAppointmentSelected = isAppointmentSelected = function(block, id) {
        return _.find(block.appointment_type_ids, function(item) {
          return item === id;
        });
      };
      $scope.addTimeslot = function() {
        var block, blocks;
        blocks = $scope.trainerAvailability.trainer_availability_blocks;
        block = EditAvailabilityService.getNewAvailabilityBlock();
        if ($scope.locations.length) {
          block.location_id = $scope.locations[0].id;
        }
        return blocks.push(block);
      };
      $scope.removeBlock = function(index) {
        var blocks;
        blocks = $scope.trainerAvailability.trainer_availability_blocks;
        if ($scope.trainerAvailability.edit_type === 'recurring') {
          return blocks.splice(index, 1);
        } else {
          return blocks[index].available = false;
        }
      };
      save = function() {
        return Availability.post($scope.trainerAvailability).then(function() {
          return $scope.showAvailability();
        }, function(response) {
          $document.scrollTop(0);
          if (response.data.message) {
            flash.error = response.data.message;
          }
          return $scope.trainerAvailability.errors = response.data.errors;
        });
      };
      $scope.save = function() {
        return EditAvailabilityService.validate($scope.trainerAvailability).then(function() {
          return save();
        }, function(response) {
          $document.scrollTop(0);
          if (response.data.message) {
            flash.error = response.data.message;
          }
          return $scope.trainerAvailability.errors = response.data;
        });
      };
      $scope.confirmSave = function() {
        return save();
      };
      return $scope.cancel = function() {
        return $scope.showAvailability();
      };
    }]
  };
});
